"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var colors_1 = require("../util/colors");
var CheckIcon = function (_a) {
    var _b = _a.scale, scale = _b === void 0 ? 1 : _b, _c = _a.lineScale, lineScale = _c === void 0 ? 1 : _c, _d = _a.color, color = _d === void 0 ? colors_1.colors.green800 : _d;
    return (react_1.default.createElement("svg", { viewBox: "0 0 24 24", width: scale * 24, height: scale * 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M20 6L9 17L4 12", stroke: color, strokeWidth: lineScale * 2, strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = CheckIcon;
//# sourceMappingURL=Check.js.map